import { Component } from '@angular/core';
import { FileFromServer } from 'src/app/core/models/files';

import { PaFileListComponent } from 'src/app/shared/ui-kit/pa-file-list/pa-file-list.component';

@Component({
  selector: 'app-file-list-view',
  standalone: true,
  imports: [PaFileListComponent],
  templateUrl: './file-list-view.component.html',
  styleUrls: ['./file-list-view.component.scss'],
})
export class FileListViewComponent {
  sampleFiles: FileFromServer[] = [
    {
      url: 'https://www.google.com/test.pdf',
    },
    {
      url: 'https://www.google.com/test.pdf',
    },
    {
      url: 'https://www.google.com/test.jpg',
    },
    {
      url: 'https://www.google.com/test.pdf',
    },
  ];

  largeFilesList: FileFromServer[] = [
    {
      url: '#',
      original_name: 'Техническое задание',
      ext: 'docx',
    },
    {
      url: '#',
      original_name: 'Отчет за квартал',
      ext: 'xlsx',
    },
    {
      url: '#',
      original_name: 'Презентация проекта',
      ext: 'pdf',
    },
    {
      url: '#',
      original_name: 'Readme',
      ext: 'txt',
    },
    {
      url: '#',
      original_name: 'Логотип компании',
      ext: 'png',
    },
    {
      url: '#',
      original_name: 'Счет-оферта №24937249672 от 22.11.2024',
      ext: 'pdf',
    },
    {
      url: '#',
      original_name: 'Договор №123/А-45',
      ext: 'pdf',
    },
    {
      url: '#',
      original_name: 'be19a16s-960',
      ext: 'jpg',
    },
    {
      url: '#',
      original_name: 'Акт сверки взаиморасчетов №13 от 13 июня 2024 г.',
      ext: 'pdf',
    },
    {
      url: '#',
      original_name: 'Счет-оферта №24937249672 от 22.11.2024',
      ext: 'pdf',
    },
    {
      url: '#',
      original_name: 'Договор №123/А-45',
      ext: 'pdf',
      },
    {
      url: '#',
        original_name: 'be19a16s-960',
      ext: 'jpg',
    },
    {
      url: '#',
      original_name: 'Акт сверки взаиморасчетов №13 от 13 июня 2024 г.',
      ext: 'pdf',
    }
  ];

  emptyFilesList: FileFromServer[] = [];
}
